import { useSearchParams } from 'react-router';

import { URL_PARAMS } from '@/constants/url-params.ts';
import { TPaginationType } from '@/types.ts';

type THookRes = {
    pagination: TPaginationType;
};

export const usePagination = (): THookRes => {
    const [searchParams] = useSearchParams();

    return {
        pagination: {
            page: Number(searchParams.get(URL_PARAMS.PAGE)) || 1,
            per_page: Number(searchParams.get(URL_PARAMS.SIZE)) || 20,
        },
    };
};
